import { useState, useEffect } from 'react';

/**
 * Shared hook for managing metric selection state
 * Used by both Dashboard and Analytics MetricsSelector components
 */
export const useMetricsSelection = <T extends string>(initialSelected: T[] = [], maxSelection: number = 4) => {
  const [selected, setSelected] = useState<T[]>(initialSelected);

  useEffect(() => {
    setSelected(initialSelected);
  }, [initialSelected]);

  const handleToggle = (id: T) => {
    setSelected((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      }
      if (prev.length >= maxSelection) {
        return prev;
      }
      return [...prev, id];
    });
  };

  const handleReset = (defaultMetrics: T[]) => {
    setSelected(defaultMetrics);
  };

  const isMaxSelected = selected.length >= maxSelection;

  return {
    selected,
    setSelected,
    handleToggle,
    handleReset,
    isMaxSelected,
  };
};
